module.exports = __webpack_public_path__ + "static/window-one-843b16fbafabac42fb93589eae73843b.jpg";